import { useEffect, useState } from "react"

import { getTeamMembersService } from "../../../../services/teamService"
import { Member } from "../../../../models/TeamMember"

import TeamCard from "../../team/teamSection/teamCard/TeamCard"

import { ReactComponent as IconArrowLeft } from "../../../../assets/img/workshops/arrow-left.svg"
import { ReactComponent as IconCheck } from "../../../../assets/img/workshops/checkmark.svg"
import { ReactComponent as IconHeart } from "../../../../assets/img/workshops/heart.svg"
import { ReactComponent as IconOnline } from "../../../../assets/img/workshops/online.svg"
import { ReactComponent as IconPerson } from "../../../../assets/img/workshops/person.svg"
import { ReactComponent as IconPlane } from "../../../../assets/img/workshops/plane.svg"

import ImageAyuno from "../../../../assets/img/workshops/ayuno.png"
import ImageComer from "../../../../assets/img/workshops/nutricion.png"
import ImagePareja from "../../../../assets/img/workshops/relacion.png"

import { Link } from "react-router-dom"

import "./workshops.css"

const WorkshopsPage = () => {
  const [workshopsTeam, setWorkshopsTeam] = useState<Member[]>([])

  useEffect(() => {
    async function fetchWorkshopsTeamMembers() {
      const members = await getTeamMembersService()
      setWorkshopsTeam(members.filter(member => member.id === 5821 || member.id === 5715))
    }
    fetchWorkshopsTeamMembers()
  }, [])

  const scrollToProductCards = () => {
    const element = document.getElementById("product-cards")
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <>
      <div className="workshops-page">
        <header className=" workshops-hero">
          <div className="workshops-hero-content">
            <h1 className="workshops-hero-title">Aprende a cuidarte</h1>
            <p className="workshops-hero-subtitle">Los talleres de Vikika Team</p>
            <button className="workshops-btn workshops-btn-primary" onClick={scrollToProductCards}>
              Quiero saber más <IconArrowLeft className="workshops-btn-icon" />
            </button>
          </div>
        </header>

        <section className="workshops-section workshops-intro">
          <div className="workshops-intro-content">
            <h2 className="workshops-section-title">
              Descubre la nueva forma de conocerte y entenderte
            </h2>
            <p className="workshops-text">
              A veces queremos mejorar y no sabemos por dónde empezar; otras nos falta claridad para
              entender lo que nos pasa...
            </p>
            <p className="workshops-text">
              Los <strong>Talleres de Vikika Team</strong> nacen con un propósito: ayudarte a
              conocerte mejor y darte herramientas prácticas para gestionar aquello que influye en
              tu bienestar diario.
            </p>
          </div>
          <div className="workshops-features">
            <div className="workshops-feature">
              <IconHeart className="workshops-feature-icon" />
              <div className="workshops-feature-content">
                <h3 className="workshops-feature-title">Técnicas sencillas</h3>
                <p>Lo hacemos entendible y aplicable para ti.</p>
              </div>
            </div>
            <div className="workshops-feature">
              <IconPerson className="workshops-feature-icon" />
              <div className="workshops-feature-content">
                <h3 className="workshops-feature-title">Ejercicios guiados</h3>
                <p>Te acompañamos para que puedas ponerlo en práctica.</p>
              </div>
            </div>
            <div className="workshops-feature">
              <IconPlane className="workshops-feature-icon" />
              <div className="workshops-feature-content">
                <h3 className="workshops-feature-title">Ejemplos concretos</h3>
                <p>Para que sepas identificar tu progreso.</p>
              </div>
            </div>
          </div>
          <blockquote className="workshops-quote">
            “Estos talleres nacen de mi propia experiencia y de lo que hemos visto en miles de
            personas de nuestra comunidad: la necesidad de un acompañamiento práctico que se aplique
            en el día a día.”
            <cite>—Vikika Costa</cite>
          </blockquote>
          <div className="workshops-section-action">
            <button className="workshops-btn workshops-btn-primary" onClick={scrollToProductCards}>
              Quiero saber más <IconArrowLeft className="workshops-btn-icon" />
            </button>
          </div>
        </section>

        <section className="workshops-section workshops-catalogue">
          <h2 className="workshops-section-title" id="product-cards">
            Sea cual sea tu punto de partida, encontrarás un taller que encaje contigo
          </h2>
          <div className="workshops-cards">
            <article className="workshops-card workshops-card-lilac">
              <img src={ImageAyuno} alt="Guía del ayuno intermitente" />
              <div className="workshops-chip">
                <IconOnline />
                <p>Online</p>
              </div>
              <div className="workshops-card-content">
                <h3 className="workshops-card-title">Guía del ayuno intermitente</h3>
                <p>
                  En este taller, entenderás de qué se trata el ayuno intermitente, cómo funciona y
                  cómo podrías integrarlo en tu estilo de vida.
                </p>
                <div className="workshops-card-buttons">
                  <Link to="/productos/taller-ayuno-intermitente" className="workshops-btn-outline">
                    Más información <IconArrowLeft className="workshops-btn-icon" />
                  </Link>
                  <a
                    href="https://vikika-team-s-school.teachable.com/l/pdp/guia-del-ayuno-intermitente"
                    className="workshops-btn workshops-btn-primary"
                  >
                    Quiero apuntarme
                  </a>
                </div>
              </div>
            </article>

            <article className="workshops-card workshops-card-green">
              <img
                src={ImageComer}
                alt="¿Comes mal porque estás mal o estás mal porque comes mal?"
              />
              <div className="workshops-chip">
                <IconOnline />
                <p>Online</p>
              </div>
              <div className="workshops-card-content">
                <h3 className="workshops-card-title">
                  ¿Comes mal porque estás mal o estás mal porque comes mal?
                </h3>
                <p>
                  Transforma tu relación con la comida y contigo mismo. Te ayudaremos a reencontrar
                  el equilibrio desde la autocompasión y la calma.
                </p>
                <div className="workshops-card-buttons">
                  <Link
                    to="/productos/taller-alimentacion-y-emociones"
                    className="workshops-btn-outline"
                  >
                    Más información <IconArrowLeft className="workshops-btn-icon" />
                  </Link>
                  <a
                    href="https://vikika-team-s-school.teachable.com/l/pdp/comes-porque-estas-mal-o-estas-mal-porque-comes"
                    className="workshops-btn workshops-btn-green"
                  >
                    Quiero apuntarme
                  </a>
                </div>
              </div>
            </article>

            <article className="workshops-card workshops-card-orange">
              <img src={ImagePareja} alt="Construir una relación de pareja sana" />
              <div className="workshops-chip">
                <IconOnline />
                <p>Online</p>
              </div>
              <div className="workshops-card-content">
                <h3 className="workshops-card-title">Construir una relación de pareja sana</h3>
                <p>
                  Las relaciones no se mantienen solas: requieren cuidado, atención y una mirada
                  consciente. Te enseñaremos a mirar tu relación desde otra perspectiva.
                </p>
                <div className="workshops-card-buttons">
                  <Link
                    to="/productos/taller-relacion-de-pareja-sana"
                    className="workshops-btn-outline"
                  >
                    Más información <IconArrowLeft className="workshops-btn-icon" />
                  </Link>
                  <a
                    href="https://vikika-team-s-school.teachable.com/l/pdp/construir-una-sana-relacion-de-pareja"
                    className="workshops-btn workshops-btn-orange"
                  >
                    Quiero apuntarme
                  </a>
                </div>
              </div>
            </article>
          </div>
        </section>

        <section className="workshops-section workshops-for-you">
          <h2 className="workshops-section-title">Estos talleres son para ti si…</h2>

          <div className="workshops-grid">
            <div className="workshops-card-simple">
              <IconCheck />
              <p>
                <strong>Nunca has ido a terapia o a un nutricionista</strong> y quieres dar un
                primer paso para entenderte y cuidarte mejor.
              </p>
            </div>
            <div className="workshops-card-simple">
              <IconCheck />
              <p>
                <strong>Ya has pasado por terapia o por nutrición personalizada</strong> y buscas un
                complemento práctico que te ayude a seguir profundizando.
              </p>
            </div>
            <div className="workshops-card-simple">
              <IconCheck />
              <p>
                <strong>Te interesa la salud y el bienestar</strong> y quieres aprender de
                profesionales cómo aplicarlo a tu vida diaria.
              </p>
            </div>
            <div className="workshops-card-simple">
              <IconCheck />
              <p>
                Simplemente <strong>quieres mejorar tu relación</strong> contigo mismo, con los
                demás o con tus hábitos.
              </p>
            </div>
          </div>

          <div className="workshops-section-action">
            <button className="workshops-btn workshops-btn-primary" onClick={scrollToProductCards}>
              Me apunto <IconArrowLeft className="workshops-btn-icon" />
            </button>
          </div>
        </section>
        <section className="workshops-section workshops-team">
          <h2 className="workshops-section-title">Te acompañaran las mejores</h2>

          <div className="workshop-team-content">
            {workshopsTeam.map((card, index) => (
              <TeamCard
                {...card}
                key={index}
                name={card.name}
                role={card.position}
                description={card.description}
                image={card.image}
                instagram_url={card.instagram_url}
              />
            ))}
          </div>
        </section>

        <section className="workshops-section workshops-contact">
          <div className="workshops-contact-content">
            <h2 className="workshops-section-title">¿Necesitas un enfoque más personalizado?</h2>
            <p className="workshops-text">
              Si necesitas un acompañamiento más personalizado, podemos ayudarte. Nuestro equipo de
              psicólogos clínicos y nutricionistas está aquí para guiarte y trabajar contigo para
              que puedas gestionar mejor todas las situaciones de la vida.
            </p>
            <Link to="/contacto/" className="workshops-btn workshops-btn-primary">
              Contacta con nosotras
            </Link>
          </div>
        </section>
      </div>
    </>
  )
}

export default WorkshopsPage
